import React, { Fragment, useState, useEffect } from 'react'
import {CloseOutlined , AccountCircleOutlined, MailOutlineOutlined, PhotoCameraOutlined, LockOutlined, CodeSharp} from '@material-ui/icons'
import {useHistory}from 'react-router-dom'
import {UpdateUserName,GetAuthCurrentUser,LogoutController,UpdateEmail, UpdatePhotoProfile} from '../../Controller'
import SideDrawer from '../Templates/SideDrawer'
import UpdateForm_text from '../Templates/UpdateProfilePage/UpdateForm_text'
import UpdateForm_filePhotoProfile from '../Templates/UpdateProfilePage/UpdateForm_fllePhotoProfile'
import '../../Css/UpdateProfile_AuthPage.scss'

const UpdateProfile_AuthPage = () => {
    const [closeNotif, setcloseNotif] = useState(true)
    const [UpdateFormSelected, setUpdateFormSelected] = useState(0)
    const [_getAuthCurrentUser, set_getAuthCurrentUser] = useState(GetAuthCurrentUser())
    let state=''
    const history = useHistory()

    useEffect(() => {
        if(!_getAuthCurrentUser){
            logout()
        }
    }, [])
    
    const logout = () => {
        LogoutController().then((res)=>{
            history.push('/')
        })
    }
    const handleUpdateEmail = (e) => {
        e.preventDefault()
        UpdateEmail(state).then((res)=>{
            logout()
        })
    }

    const handleUpdateUserName = (e) => {
        e.preventDefault()
        UpdateUserName(state).then(res=>{
            history.push('/Home')
        })
    }

    const handleUpdatePhotoProfile = () => {
        UpdatePhotoProfile(state[0]).then(res=>{
            history.push('/Home')
        })
        
    }

    const handleInput = (data) => {
        state=data
    }

    const ReturnFormFalidation = () => {
        if (UpdateFormSelected ==1 ) {
            return <UpdateForm_text
                updateLabel="Input New Name"
                updateButtonLabel = "Update Name"
                type= "text"
                placeholder="Nama user"
                onInput={data=> handleInput(data)}
                onClick = {(e)=>handleUpdateUserName(e)}
            />
        }
        else if (UpdateFormSelected ==2 ) {
            return <UpdateForm_text
                updateLabel="Input New Email"
                updateButtonLabel = "Update Email"
                type = "email"
                placeholder="user@email.com"
                onInput={data=> handleInput(data)}
                onClick = {(e)=>handleUpdateEmail(e)}
            />
        }
        else if (UpdateFormSelected ==3 ) {
            return <UpdateForm_filePhotoProfile
                updateLabel="Update New Profil Picture"
                updateButtonLabel = "Update Profil Picture"
                type = "file"
                onInput={data=> handleInput(data)}
                onClick = {(e)=>handleUpdatePhotoProfile(e)}
            />
        }
        else if (UpdateFormSelected ==4 ) {
            return <UpdateForm_text
                updateLabel="Input New Password"
                updateButtonLabel = "Update Password"
                type = "password"
                placeholder="............"
                onInput={data=> handleInput(data)}
                onClick = {handleUpdateUserName}
                

            />
        }
        
        return (
            <Fragment>
                
            </Fragment>
        )
        
    }

    return(
        <Fragment>
            <SideDrawer
                home={false}
            />
            <section className="parentUpdateAuth_wrapper">
                <div className="UpdateAuthWrapper">
                   
                        <div className="notifWrapper" style={closeNotif? {} :{display:"none"}}>
                            <div className="notifClose"  onClick={()=>setcloseNotif(closeNotif? false:true)}>
                                <CloseOutlined/>
                            </div>
                            <div className= "notifMessage">
                                <h3>
                                    Change your password frequently
                                </h3>
                                    <p>
                                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Fugiat molestias architecto aliquid quae voluptatem repellat nemo similique dolorem molestiae repellendus!
                                    </p>
                            </div>
                        </div>
                        <div className = "updateParentForm">
                            <div className = "updateAuthMenu_titleWrapper">
                                
                                <div className = "menus">
                                    <div className="title">
                                        <p>
                                            Authentication Update
                                        </p>
                                    </div>
                                    <ul>
                                        <li>
                                            <a href="#" type="button" 
                                                onClick ={(e) => {
                                                    setUpdateFormSelected(1)
                                                    e.preventDefault()
                                                }}><AccountCircleOutlined/>Name
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#" type="button" 
                                                onClick ={(e) => {
                                                    setUpdateFormSelected(2)
                                                    e.preventDefault()
                                                }}><MailOutlineOutlined/>Email
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#" type="button" 
                                                onClick ={(e) => {
                                                    setUpdateFormSelected(3)
                                                    e.preventDefault()
                                                }}><PhotoCameraOutlined/>Profil Picture
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#" type="button" 
                                                onClick ={(e) => {
                                                    setUpdateFormSelected(4)
                                                    e.preventDefault()
                                                }}><LockOutlined/>Password
                                            </a>
                                        </li>
                                        
                                    </ul>
                                </div>
                            </div>
                            <div className = "updateAuthMenu_menuWrapper">
                                <ReturnFormFalidation/>  
                            </div>
                        </div>
                </div>
            </section>
        </Fragment>
    )
    
}

export default UpdateProfile_AuthPage